import { connect } from 'react-redux'

import * as session from '../session'

import { PrivateRoute as Component } from './private-route'

export const PrivateRoute = connect(state => ({
  authenticated: session.isAuthenticated(state.session),
}))(Component)
